import { serializable, alias, primitive } from 'serializr';

export class Product {
  @serializable(alias('id', primitive()))
  id?: number;

  @serializable(alias('name', primitive()))
  name?: string;

  @serializable(alias('brand_id', primitive()))
  brandId?: number;

  @serializable(alias('net_weight', primitive()))
  netWeight?: number;

  @serializable(alias('net_weight_unit', primitive()))
  netWeightUnit?: string;

  @serializable(alias('description', primitive()))
  description?: string;

  @serializable(alias('gross_weight', primitive()))
  grossWeight?: number;

  @serializable(alias('temperature_control', primitive()))
  temperatureControl?: string;

  @serializable(alias('density', primitive()))
  density?: number;

  @serializable(alias('processing_facility_id', primitive()))
  processingFacilityId?: number;

  @serializable(alias('reporting_period_units', primitive()))
  reportingPeriodUnits?: number;

  @serializable(alias('reporting_period', primitive()))
  reportingPeriod?: string;

  @serializable(alias('reporting_year', primitive()))
  reportingYear?: number;

  @serializable(alias('processing_facility_cost_percentage', primitive()))
  processingFacilityCostPercentage?: number;

  @serializable(alias('status', primitive()))
  status?: string;

  @serializable(alias('stage', primitive()))
  stage?: number;

  @serializable(alias('emission', primitive()))
  emission?: number;

  @serializable(alias('brand_name', primitive()))
  brandName?: string;

  @serializable(alias('processing_facility_name', primitive()))
  processingFacilityName?: string;

  @serializable(alias('createdAt', primitive()))
  createdAt?: string;

  @serializable(alias('updatedAt', primitive()))
  updatedAt?: string;

  @serializable(alias('b2b', primitive()))
  b2b?: number;

  @serializable(alias('b2c', primitive()))
  b2c?: number;

  @serializable(alias('image', primitive()))
  image?: string;

  @serializable(alias('reject_reason', primitive()))
  rejectReason?: string;

  @serializable(alias('unique_id'))
  uniqueId?: string;
}
